export { default } from './RecentJobsCard';



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/react_app/components/RecentJobsCard/index.js